<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link
          :to="`/businesses_change`"
          :key="`businesses`"
          :name="$store.state.text['change_school']"
          :icon="`ti-arrow-circle-left`"
        />

        <sidebar-link
          :to="`/dashboard`"
          :key="`dashboard`"
          :name="$store.state.text['main']"
        />

        <sidebar-link
          v-for="(route, key) in routes"
          :to="`/${route.path}`"
          :key="key"
          :name="route.title"
        />

        <!--   :icon="route.icon"-->
        <!--       :icon="`ti-power-off`"-->
        <li class="nav-item">
          <a
            class="nav-link"
            :href="`https://kundalik.com/teachers`"
            target="_blank"
            >KUNDALIK</a
          >
        </li>

        <sidebar-link
          :to="`/quit`"
          :key="`quit`"
          :name="$store.state.text['quit']"
        />
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["routes"]),
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>

<style>
.logout {
  border: none;
  box-shadow: none;
  width: 100%;
  position: absolute;
  bottom: 30px;
  background: transparent;
  color: #fff;
  font-size: 20px;
  text-align: left;
  padding: 10px 25px;
}
</style>
